<template>
  <div>
    <div class="up-input-group">
      <div>
        <up-numberinput
          v-model="grid_translator.styles.width"
          size="sm"
          label="Width"
          labelIcon="mdi mdi-alpha-w-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="grid_translator.styles.height"
          size="sm"
          label="Height"
          labelIcon="mdi mdi-alpha-h-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-textinput
          v-model="grid_translator.text_styles.font_color"
          size="sm"
          label="Color"
        ></up-textinput>
      </div>
      <div>
        <up-numberinput
          v-model="grid_translator.text_styles.font_size"
          size="sm"
          label="Font Size"
        ></up-numberinput>
      </div>
      <div>
        <up-textinput
          v-model="grid_translator.letter"
          size="sm"
          label="Letter"
        ></up-textinput>
      </div>
      <div>
        <up-numberinput
          v-model="grid_translator.modification.margin_top"
          size="sm"
          label="Margin Top"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="grid_translator.modification.margin_left"
          size="sm"
          label="Margin Left"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="grid_translator.modification.rotate_deg"
          size="sm"
          label="Rotate Degree"
        ></up-numberinput>
      </div>
      <div>
        <up-switch
          v-model="grid_translator.modification.is_horizontal_flip"
          label="Is Horizontal Flip"
          labelIcon="mdi mdi-alpha-h-box-outline"
        ></up-switch>
      </div>
      <div>
        <up-switch
          v-model="grid_translator.modification.is_vertical_flip"
          label="Is Vertical Flip"
          labelIcon="mdi mdi-alpha-v-box-outline"
        ></up-switch>
      </div>
    </div>
    <!-- <div class="columns is-multiline">
      <div class="column is-12">
        <style-editor
          title="box"
          v-model="grid_translator.styles"
        ></style-editor>
      </div>
    </div> -->
    <show-grid-translator :grid_translator="grid_translator"></show-grid-translator>
  </div>
</template>

<script>
import { defaultGridTranslatorValue } from "./utils";
import ShowGridTranslator from "./ShowGridTranslator";
// import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
export default {
  name: "set-grid-translator",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowGridTranslator,
    // StyleEditor,
    UpTextinput,
    UpNumberinput,
    UpSwitch,
  },
  data() {
    return {
      grid_translator: this.value ? this.value : defaultGridTranslatorValue(),
    };
  },
  watch: {
    grid_translator: {
      handler: function (new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function (new_val) {
        this.grid_translator = new_val;
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>